// extracted by mini-css-extract-plugin
export default {"ThreadDetailsBody":"MailboxPage_ThreadDetailsBody__0FEou","Wrapper":"MailboxPage_Wrapper__gE0Uj"};